"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAccordionContext = exports.AccordionContext = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
exports.AccordionContext = react_1.default.createContext({
    expanded: false,
    setExpanded: lodash_1.noop,
    isVisualStyleAccordion: false,
    backgroundImageUrl: "",
    handleSwapImageClick: lodash_1.noop,
    handleVisualAccordionImageClick: lodash_1.noop,
    showControls: false,
    style: {},
});
var withAccordionContext = function (Comp) {
    var WithAccordion = function (props) { return (react_1.default.createElement(exports.AccordionContext.Consumer, null, function (context) {
        var newProps = __assign({ context: context }, props);
        return react_1.default.createElement(Comp, __assign({}, newProps));
    })); };
    return WithAccordion;
};
exports.withAccordionContext = withAccordionContext;
